import { HttpClient } from '@angular/common/http'
import { Injectable, OnDestroy } from '@angular/core'
import { catchError, Observable, Subscription } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class FilterService implements OnDestroy {
  private unsubscribe: Subscription[] = []
  constructor(private _http: HttpClient) {}
  getUserList(): Observable<any> {
    return this._http
      .get<any>('/users/userlist')
      .pipe(catchError(this.handleError))
  }
  GetBranchFilterList(br: any): Observable<any> {
    return this._http
      .post<any>('/api/rep/GetPendingBranch', br)
      .pipe(catchError(this.handleError))
  }
  Getservicesponsorinsurancelist(): Observable<any> {
    return this._http
      .get<any>('/api/Types/Getsponsorinsurancelist')
      .pipe(catchError(this.handleError))
  }
  Getservicesponsortradingfaxlist(): Observable<any> {
    return this._http
      .get<any>('/api/Types/Getsponsortradingfaxlist')
      .pipe(catchError(this.handleError))
  }
  Getservicesponsorgtradinfaxlist(): Observable<any> {
    return this._http
      .get<any>('/api/Types/Getsponsortradingfaxlist')
      .pipe(catchError(this.handleError))
  }
  GetserviceaccountReports(data: any): Observable<Blob> {
    const paramblob = {
      blotterId: data,
    } 
    return this._http
      .post(`/api/Types/opensaveaccountreceipt`, paramblob, { responseType: 'blob' })
      .pipe(catchError(this.handleError))
  }
  /*   GetCODFaxReturndata(data: any): Observable<Blob>  {
    return this._http
      .post<any>('/api/Types/op1enFactheet', data, { responseType: 'blob')
      .catch(this.handleError);
  } */
  GetCODFaxReturndata(data: any): Observable<Blob> {
    return this._http
      .post(`/api/Types/openFactsheet`, data, { responseType: 'blob' })
      .pipe(catchError(this.handleError))
  }
  GetemptyCODFaxReturndata(): Observable<Blob> {
    return this._http
      .get(`/api/Types/openFacblanksheet`, { responseType: 'blob' })
      .pipe(catchError(this.handleError))
  }
  private handleError(error: any) {
    let errMsg: string
    if (error instanceof Response) {
      const body = error.json() || ''
      const err = body || JSON.stringify(body)
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`
    } else {
      errMsg = error.message ? error.message : error.toString()
    }
    return Promise.reject(errMsg)
  }
  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe())
  }
}
